import { getInstance } from '@portal/repositories/securitySdkConfig';

const BankApi = {
  getBanks: async () => {
    const instance = await getInstance();
    const { data } = await instance.get(`/bank`);

    return data;
  },

  getBankDetails: async (id: string) => {
    const instance = await getInstance();
    const { data } = await instance.get(`/bank/${id}`);

    return data;
  },

  createBank: async (params: unknown) => {
    const instance = await getInstance();
    const { data } = await instance.post(`/bank`, params);

    return data;
  },

  updateBank: async (params: unknown, id: string) => {
    const instance = await getInstance();
    const { data } = await instance.put(`/bank/${id}`, params);

    return data;
  },

  deleteBank: async (id: string) => {
    const instance = await getInstance();
    const { data } = await instance.delete(`/bank/${id}`);

    return data;
  },
};

export default BankApi;
